var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataSyncV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.66602C9.8995 4.66602 12.25 3.88251 12.25 2.91602C12.25 1.94952 9.8995 1.16602 7 1.16602C4.1005 1.16602 1.75 1.94952 1.75 2.91602C1.75 3.88251 4.1005 4.66602 7 4.66602Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 7C1.74916 7.32617 2.0218 7.64593 2.53717 7.9232C3.05253 8.20046 3.79011 8.4242 4.66667 8.56917",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 5.42435V2.91602",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 2.91602V11.0827C1.74963 11.4611 2.11722 11.8293 2.79767 12.1322C3.47811 12.4351 4.43475 12.6563 5.52417 12.7627",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2002 7.19922V9.19894H9.19991",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2002 9.19902L7.96759 8.39663C8.25457 8.12082 8.60326 7.91753 8.98466 7.80367C9.36606 7.68981 9.76913 7.66868 10.1603 7.74203C10.5516 7.81538 10.9196 7.9811 11.2338 8.22539C11.5481 8.46968 11.7995 8.78548 11.967 9.14652",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1999 13.1989V11.1992H10.2002",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2004 11.1992L11.433 12.0016C11.1461 12.2774 10.7974 12.4807 10.416 12.5946C10.0346 12.7084 9.63149 12.7296 9.24027 12.6562C8.84906 12.5828 8.48102 12.4171 8.16677 12.1728C7.85253 11.9286 7.60116 11.6127 7.43359 11.2517",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataSyncV2);
export default __webpack_public_path__ + "static/media/dataSyncV2.d7ed9b4ad4168c783c6f17299f4fe542.svg";
export { ForwardRef as ReactComponent };